import React, { useState, useEffect } from 'react';
import {
  Paper,
} from '@material-ui/core';
import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';
import Tooltip from '@material-ui/core/Tooltip';
import IconButton from '@material-ui/core/IconButton';
import useStyle from './useStyle';
import DeviceTable from './components/DataTable/DeviceTable.readonly';
import newButton from '../../assets/img/iconos/newButton.svg';
import searchIcon from '../../assets/img/iconos/searchIcon.svg';
import {
  getDevicesService,
} from '../../services';

const DeviceScreen = () => {
  const classes = useStyle();
  const [devices, setDevices] = useState();
  const [enteredFilter, setEnteredFilter] = useState('');
  const getDevices = async () => {
    try {
      const res = await getDevicesService();
      setDevices(res?.data);
    } catch (e) {
      console.log(e);
    }
  };

  useEffect(() => {
    getDevices();
  }, []);

  return (
    <Paper className={classes.paper}>
      <>
        <div className={classes.root}>
          <div>
            <TextField
              className={classes.searchTextField}
              value={enteredFilter}
              onChange={(e) => setEnteredFilter(e.target.value)}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <img src={searchIcon} alt="searchIcon" style={{ paddingLeft: '10px' }} />
                  </InputAdornment>
                ),
                disableUnderline: true,
              }}
              placeholder="Buscar"
            />
            <Tooltip title="Crear banner" aria-label="Nuevo banner">
              <IconButton
                style={{ fontSize: '20px', float: 'right', opacity: 0.4 }}
                edge="end"
                size="small"
                disabled
              >
                <img src={newButton} alt="newButton" />
              </IconButton>
            </Tooltip>
          </div>
          <DeviceTable
            devices={devices}
            enteredFilter={enteredFilter}
          />
        </div>
      </>
    </Paper>
  );
};

export default DeviceScreen;
